"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.CircularBuffer = exports.ReadOnlyCircularBuffer = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _getIterator2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/get-iterator"));

var _iterator = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/symbol/iterator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _sourceBuffer = '@@_sourceBuffer';

var ReadOnlyCircularBuffer = function () {
  function ReadOnlyCircularBuffer(sourceBuffer) {
    (0, _classCallCheck2["default"])(this, ReadOnlyCircularBuffer);
    this[_sourceBuffer] = sourceBuffer;
  }

  (0, _createClass2["default"])(ReadOnlyCircularBuffer, [{
    key: "get",
    value: function get(idx) {
      return this[_sourceBuffer].get(idx);
    }
  }, {
    key: "peek",
    value: function peek() {
      return this[_sourceBuffer].peek();
    }
  }, {
    key: "isFull",
    value: function isFull() {
      return this[_sourceBuffer].isFull();
    }
  }, {
    key: _iterator["default"],
    value: function value() {
      return (0, _getIterator2["default"])(this[_sourceBuffer]);
    }
  }, {
    key: "size",
    get: function get() {
      return this[_sourceBuffer].size;
    }
  }, {
    key: "capacity",
    get: function get() {
      return this[_sourceBuffer].capacity;
    }
  }]);
  return ReadOnlyCircularBuffer;
}();

exports.ReadOnlyCircularBuffer = ReadOnlyCircularBuffer;

var CircularBuffer = function () {
  function CircularBuffer(size) {
    (0, _classCallCheck2["default"])(this, CircularBuffer);
    this._array = new Array(size);
    this._head = size - 1;
    this.size = 0;
  }

  (0, _createClass2["default"])(CircularBuffer, [{
    key: "push",
    value: function push(newItem) {
      var array = this._array;
      var head = this._head = (this._head + 1) % array.length;
      var displacedItem = array[head];
      array[head] = newItem;

      if (this.isFull()) {
        return displacedItem;
      } else {
        this.size++;
        return undefined;
      }
    }
  }, {
    key: "shift",
    value: function shift() {
      if (!this.size) return undefined;
      var value = this.get(0);
      this.size--;
      return value;
    }
  }, {
    key: "peek",
    value: function peek() {
      return this.get(0);
    }
  }, {
    key: "fill",
    value: function fill(filler) {
      this._array.fill(filler);

      this.size = this._array.length;
    }
  }, {
    key: "get",
    value: function get(idx) {
      if (idx >= this.size) return undefined;
      var array = this._array;
      var head = this._head;
      var index = (array.length + head - this.size + 1 + idx) % array.length;
      return array[index];
    }
  }, {
    key: "isFull",
    value: function isFull() {
      return this.size === this._array.length;
    }
  }, {
    key: _iterator["default"],
    value: _regenerator["default"].mark(function value() {
      var i;
      return _regenerator["default"].wrap(function value$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              i = 0;

            case 1:
              if (!(i < this.size)) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return this.get(i);

            case 4:
              i++;
              _context.next = 1;
              break;

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, value, this);
    })
  }, {
    key: "capacity",
    get: function get() {
      return this._array.length;
    }
  }]);
  return CircularBuffer;
}();

exports.CircularBuffer = CircularBuffer;